import Axios from "../utils/axiosInstance";

// API for getting all tasks list
export const getAllTasksList = (headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tasks/getAllTasksList`, {
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting task list by ID
export const getTaskListById = (pkUserId, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tasks/taskListById`, {
    params: { pkUserId },
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for creating new task
export const createTask = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/tasks/createTask`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for updating task
export const updateTask = (taskId, payload, headers) => {
  let token = sessionStorage.getItem("token");
  const cleanId = typeof taskId === "string" ? taskId.replace(/\D/g, "") || taskId : taskId;
  return Axios.put(`/tasks/updateTask/${cleanId}`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getAllTasks = getAllTasksList;
export const getAllTasksAPI = getAllTasksList;
export const getAllTasksListAPI = getAllTasksList;
export const createTaskAPI = createTask;
export const postCreateTask = createTask;
export const updateTaskAPI = updateTask;
export const putUpdateTask = updateTask;
export const getTaskListByIdAPI = getTaskListById;

export const AllTaskTrackerAPI = {
  getAllTasksList,
  getAllTasksListAPI,
  getAllTasks,
  getAllTasksAPI,
  getTaskListById,
  getTaskListByIdAPI,
  createTask,
  createTaskAPI,
  postCreateTask,
  updateTask,
  updateTaskAPI,
  putUpdateTask,
};

export default AllTaskTrackerAPI;
